import * as React from 'react'

import { TableAlign } from '../../components/Table'
import { EarningsCommonData, EarningsEstimateType, PriceReactionWhen } from '../earnings-common/types'

export type EarningRevision = {
  ticker: string
  fiscalPeriod: string
  estimateType: EarningsEstimateType
  estimateDate: string
  relativeFiscalPeriod: number
  estimates: number
  upRevisions: number
  downRevisions: number
  mean: number
  high: number
  low: number
  price: number
}

export type EarningRevisionWithDate = EarningRevision & { date: Date; negDownRevisions?: number }

export interface EarningsData extends EarningsCommonData {
  earningsRevisionsData: EarningRevision[]
}

export type EarningsRevisionsByType = {
  [estimateType in EarningsEstimateType]: {
    quarters: { [quarter: string]: EarningRevisionWithDate[] }
    years: { [year: string]: EarningRevisionWithDate[] }
  }
}

export enum PriceReactionDataEnum {
  priceDiff = 'priceDiff',
  spyPriceDiff = 'spyPriceDiff',
}

export type PriceReactionSubRowDataType = {
  id: string
  label: string
  labelElement?: React.ReactNode
  labelColumnClassName?: string
  values: Array<{ when: PriceReactionWhen; value: number | null }>
}

export type PriceReactionRowDataType = PriceReactionSubRowDataType & {
  subData: PriceReactionSubRowDataType[]
}

type PriceReactionColumnDefinitionBase<RowDataType> = {
  id: string
  name: string
  align?: TableAlign
  className?: string
  getColumnClassName?: (data: RowDataType) => string | null | undefined
  renderColumn: (data: RowDataType) => React.ReactNode
}

export type PriceReactionColumnDefinition = PriceReactionColumnDefinitionBase<PriceReactionRowDataType> & {
  bottomBorderClassName?: string
  hasLeftBorder?: boolean
  hasLeftSeparator?: boolean
  hasRightBorder?: boolean
  hasRightSeparator?: boolean
  headerClassName?: string
  isSeparator?: boolean
  leftBorderClassName?: string
  rightBorderClassName?: string
  topBorderClassName?: string
}

export type PriceReactionSubColumnDefinition = PriceReactionColumnDefinitionBase<PriceReactionSubRowDataType>

export type PriceReactionColumnsType = {
  columns: PriceReactionColumnDefinition[]
  subColumns: Record<PriceReactionDataEnum, PriceReactionSubColumnDefinition[]>
}

type RevisionsChartItem = EarningRevisionWithDate & {
  lowHigh: [number, number]
  timestamp: number
}

export type RevisionsChartData = RevisionsChartItem[]
